import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

const TimeBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const TimerIcon = styled.div`
  justify-content: left;
`;

const TimerTime = styled.div`
  justify-content: right;
`;

export const PriceTimer = ({ time, className }) => {
  const hours = Math.floor(time / (60 * 60));
  const minutes = Math.floor((time - hours * 60 * 60) / 60);
  const seconds = time % 60;

  const convertNumberToString = (number) => `0${number}`.slice(-2);
  return (
    <TimeBody className={className}>
      <TimerIcon className={'timeIcon'}>
        <AccessTimeIcon />
      </TimerIcon>
      <TimerTime className={'timerValue'}>
        {hours > 0 ? `${hours}h ${convertNumberToString(minutes)}m` : `${convertNumberToString(minutes)}m ${convertNumberToString(seconds)}s`}
      </TimerTime>
    </TimeBody>
  );
};

PriceTimer.propTypes = {
  time: PropTypes.number,
  className: PropTypes.string,
};

